import { render, staticRenderFns } from "./main-tutor-list.html?vue&type=template&id=0066e688&scoped=true&"
import script from "./main-tutor-list.ts?vue&type=script&lang=ts&"
export * from "./main-tutor-list.ts?vue&type=script&lang=ts&"
import style0 from "./main-tutor-list.styl?vue&type=style&index=0&id=0066e688&lang=styl&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0066e688",
  null
  
)

export default component.exports